import { NgClass } from '@angular/common';
import {
  Component,
  computed,
  ElementRef,
  inject,
  signal,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { takeUntil, tap, timer } from 'rxjs';
import { selectConfigLoading } from 'src/app/store/states/config/config.selectors';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [NgClass],
})
export class LoadingDefaultComponent implements AfterViewInit {
  @ViewChild('title') titleElement!: ElementRef;
  private store = inject(Store);
  protected loadingState = this.store.selectSignal(selectConfigLoading);
  private content = computed(() => this.loadingState().loadingConfig.content);
  private contentIndex = signal(0);
  protected actualContent = computed(() => this.content()![this.contentIndex()]);
  private readonly oneMinuteInMilliseconds = 60 * 1000;

  ngAfterViewInit(): void {
    this.startTitleChangeInterval();
  }

  private startTitleChangeInterval() {
    if (this.titleElement) {
      const titleChangeBasedAnimation = 5 * 1000;
      timer(0, titleChangeBasedAnimation)
        .pipe(
          takeUntil(timer(this.oneMinuteInMilliseconds)),
          tap(() => {
            this.contentIndex.set((this.contentIndex() + 1) % (this.content()?.length || 0));
          })
        )
        .subscribe();
    }
  }
}
